// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f698b459","377":"51e1b8c0","498":"0a1aa175","703":"f5295b10"}[chunkId] + ".chunk.js";
};